import { TxtAttach } from "./index.model";

export class CodedInfo {
    CodeValueID: string;
    JurisID: number;
    CodeValue: string;
    Custom4: string;
    XRef1: string;
    TxtAttach: TxtAttach;
}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/codedinfo.model.ts